import React, { Component } from 'react'
import { connect } from 'react-redux'
import { 
    Box, 
    FormControl, 
    Input, 
    InputAdornment, 
    IconButton, 
    Icon, 
    Switch, 
    Grid,
    Button,
    SvgIcon } from '@material-ui/core'
import { viewStyles, buttonStyles } from '../styles/styles'
import DraggableList from 'react-draggable-list'
import { changeOptionList, deleteElement, addNewOption, changeNameElement, changeOptionIsHalf, toggleIsRequiredOption } from '../actions/settings'

import { ReactComponent as PlusIcon } from '../styles/images/plus.svg'
import { ReactComponent as BurgerIcon } from '../styles/images/burger.svg'
import { ReactComponent as TrashIcon } from '../styles/images/trash.svg'

class FormOptionItem extends Component{

    render(){
        const { item, dragHandleProps } = this.props;
        const { deleteElement, changeName, classes, btnStyles, options, addOption } = this.props.commonProps;
        return(
            <Box>
                <FormControl  className={classes.listRow}>
                    <Input
                        id=""
                        type='text'
                        value={item.value}
                        onChange={(e) => { changeName(e.target.value, item.id, 'option') }}                    
                        endAdornment={
                        <InputAdornment position="end">                                                     
                            <IconButton size="small" onClick={() => deleteElement(item, "option")}>
                                <SvgIcon component={TrashIcon} viewBox="0 0 12 14" className={classes.svgIcon} />
                            </IconButton>
                            <Icon {...dragHandleProps} size="small" className={btnStyles.move}>
                                <SvgIcon component={BurgerIcon} viewBox="0 0 11.782 9.91" className={classes.svgIcon} />
                            </Icon>
                            {
                                options[options.length - 1].id === item.id ?
                                <IconButton size="small" onClick={() => addOption()} className={btnStyles.addOption}>
                                    <SvgIcon component={PlusIcon} viewBox="0 0 23 17" className={classes.svgIcon} />
                                </IconButton>
                                :
                                <></>
                             }
                        </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
        )
    }
}


const OptionsList = ({ 
    settings, 
    onListChange, 
    deleteElement, 
    addOption, 
    changeName, 
    changeFlag,
    toggleIsRequired 
}) => {
    
    if(settings.editingElement !== null){
        let _container = HTMLElement
        const classes = viewStyles()
        const btnStyles = buttonStyles()
        return(
            <Grid container justifyContent="space-between">
                {/* <Grid item xs={12}>
                    <Box m="10px 0 20px 0">Options:</Box>
                </Grid> */}
                {
                    (() => {
                        if(settings.editingElement.canBeHalf){
                            return(
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" m="0 0 10px">
                                        <Box className={classes.optionFieldTitle}>Half width of form:</Box>
                                        <Switch size="small" 
                                            checked={settings.editingElement.isHalf} 
                                            onChange={(e) => {changeFlag(e.target.checked)}}
                                            className={classes.switch}></Switch>
                                    </Box>                                    
                                </Grid>                                
                            )
                        }
                    })()
                }

                {
                    (() => {
                        if(settings.editingElement.name !== "separator"){
                            return(
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" m="0 0 10px">
                                        <Box className={classes.optionFieldTitle}>This field is Required:</Box>
                                        <Switch size="small" 
                                            checked={settings.editingElement.isRequired} 
                                            onChange={(e) => {toggleIsRequired(e.target.checked)}}
                                            className={classes.switch}></Switch>
                                    </Box>                                    
                                </Grid>                                
                            )
                        }
                    })()
                }

                {
                    (() => {
                        if(settings.editingElement.hasOptions){
                            return(
                                <Grid item xs={12}>
                                    <Box id="options-container" className={classes.listElementsContainer} ref={el => { if (el) _container = el; }}>
                                        <DraggableList 
                                            itemKey="id"
                                            template={FormOptionItem}
                                            list={settings.editingElement.options}
                                            onMoveEnd={newList => onListChange(newList)}
                                            commonProps={{
                                                deleteElement,
                                                changeName,
                                                classes,
                                                btnStyles,
                                                addOption,
                                                options: settings.editingElement.options
                                            }}
                                            container={() => _container}
                                            />
                                    </Box>
                                    {/* <Box>
                                        <Button className={btnStyles.add} onClick={() => addOption()}>add</Button>
                                    </Box> */}
                                </Grid>
                            )
                        }
                    })()
                }              
                
            </Grid>            
        )
    }else{
        return(
            <div></div>
        )
    }
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    onListChange: (newList) => dispatch(changeOptionList(newList)),
    deleteElement: (element, name) => dispatch(deleteElement(element, name)),
    addOption: () => dispatch(addNewOption()),
    changeName: (name, id, kind) => dispatch(changeNameElement(name, id, kind)),
    changeFlag: (flag) => dispatch(changeOptionIsHalf(flag)),
    toggleIsRequired: (flag) => dispatch(toggleIsRequiredOption(flag))
})

export default connect(mapStateToProps, mapDispatchToProps)(OptionsList)